module.exports = __webpack_public_path__ + "static/result_incheon-fe5b1f8ae7ce22abd65d342fd8034e24.png";